import React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import AuthLayout from 'layouts/AuthLayout'
import Login from 'components/PageComponents/Auth/Login'

const LoginPage = () => (
  <>
    <Helmet>
      <title>Skefto: Login</title>
    </Helmet>
    <AuthLayout>
      <Login />
    </AuthLayout>
  </>
)

export default LoginPage
